import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/elementor-7428")({
  beforeLoad: () => {
    throw redirect({ to: "/services-directory" });
  },
});
